import { Form, Table, Input, Checkbox, Button, Space, Typography } from 'antd';
import React, { useMemo } from 'react';
import PhoneNumberDTO from 'src/models/PhoneNumberDTO';
import EmailDTO from 'src/models/EmailDTO';
import AutomationType from 'src/consts/AutomationType';

const { Text } = Typography;

interface UserEmailPhoneNumberProps {
  automationType: AutomationType;
}

const UserEmailPhoneNumber: React.FC<UserEmailPhoneNumberProps> = ({ automationType }) => {

  const getColumns = (remove: (index: number) => void, type: 'email' | 'phone') => {
    const columns: any[] = [
      {
        title: type === 'email' ? 'Email Address' : 'Phone Number',
        dataIndex: type === 'email' ? 'email' : 'phoneNumber',
        key: type === 'email' ? 'email' : 'phoneNumber',
        render: (_: unknown, record: { index: number }) => (
          <Form.Item
            name={[record.index, type === 'email' ? 'email' : 'phoneNumber']}
            rules={[
              { required: true, message: `Please enter a ${type === 'email' ? 'email' : 'phone number'}` },
              ...(type === 'email'
                ? [{ type: 'email' as const, message: 'Enter a valid email' }]
                : []),
            ]}
            style={{ margin: 0 }}
          >
            <Input placeholder={type === 'email' ? 'name@example.com' : '555 123 4567'} />
          </Form.Item>
        ),
      },
    ];

    columns.push({
      title: 'Receive notifications?',
      dataIndex: 'receiveNotifications',
      key: 'receiveNotifications',
      align: 'center' as const,
      width: 200,
      render: (_: unknown, record: { index: number }) => (
        <Form.Item
          name={[record.index, 'receiveNotification']}
          valuePropName="checked"
          style={{ margin: 0 }}
        >
          <Checkbox />
        </Form.Item>
      ),
    });

    columns.push({
      title: 'Actions',
      key: 'actions',
      align: 'right' as const,
      width: 140,
      render: (_: unknown, record: { index: number }) => (
        <Space>
          <Button danger onClick={() => remove(record.index)}>
            Remove
          </Button>
        </Space>
      ),
    });

    return columns;
  };

  return (
    <>
      {/* Emails */}
      <Form.List name="emails">
        {(fields, { add, remove }) => {
          const dataSource = fields.map((f) => ({ key: f.key, index: f.name }));
          return (
            <div style={{ marginBottom: 24 }}>
              <Space style={{ marginBottom: 8 }} align="baseline">
                <Text strong>Emails</Text>
                <Button type="dashed" onClick={() => add({ email: '', receiveNotification: true, automationTypeId: automationType })}>
                  Add email
                </Button>
              </Space>
              <Table
                size="middle"
                pagination={false}
                dataSource={dataSource}
                columns={getColumns(remove, 'email')}
                rowKey="key"
                bordered
              />
            </div>
          );
        }}
      </Form.List>

      {/* Phone Numbers */}
      <Form.List name="phoneNumbers">
        {(fields, { add, remove }) => {
          const dataSource = fields.map((f) => ({ key: f.key, index: f.name }));
          return (
            <div>
              <Space style={{ marginBottom: 8 }} align="baseline">
                <Text strong>Phone Numbers</Text>
                <i>Do not include country code, US only</i>
                <Button type="dashed" onClick={() => add({ phoneNumber: '', receiveNotification: true, automationTypeId: automationType })}>
                  Add phone
                </Button>
              </Space>
              <Table
                size="middle"
                pagination={false}
                dataSource={dataSource}
                columns={getColumns(remove, 'phone')}
                rowKey="key"
                bordered
              />
            </div>
          );
        }}
      </Form.List>
    </>
  );
};

export default UserEmailPhoneNumber;
